'use strict';

import * as _ from 'lodash';
import moment from 'moment';

const angular = require('angular');
const uiRouter = require('angular-ui-router');
import uiBootstrap from 'angular-ui-bootstrap';

import routes from './createapp.routes';
import { AppComponent } from '../application/application.component';


export class AppCreateComponent {
  constructor($http, $scope, $state, $stateParams, $window) {   
    $scope.saving = false;
    $scope.ready = false;
    $scope.appName;
    $scope.description;
    $scope.phone;
    $scope.email;
    $scope.selectedFile = undefined;

    if($stateParams.id) {
      $http.get(`/api/applications/${$stateParams.id}`).then(res => {
        $scope.app = res.data;
        $scope.appName = $scope.app.name;
        $scope.description = $scope.app.description;
        $scope.phone = $scope.app.phone;
        $scope.email = $scope.app.email;
        $scope.ready = true;
      });
    }
    else {
      $scope.ready = true;
    }

    $scope.selectFile = () => {
      document.getElementById('selectImage').click();        
    };

    $scope.saveChanges = () => {
      if(!$scope.isDataValid())
        return;
      
      $scope.saving = true;
      const body = {
        name: $scope.appName,
        description: $scope.description,
        phone: $scope.phone,
        email: $scope.email
      };

      if($scope.selectedFile && $scope.selectedFile.base64 && $scope.selectedFile.base64 !== '') {
        body.image = {
          imageData: $scope.selectedFile.base64,
          contentType: $scope.selectedFile.type
        };
      }

      const updateReq = $scope.app ? $http.put(`/api/applications/${$scope.app.id}`, body) : $http.post('/api/applications', body);

      updateReq.then(res => {
        const app = res.data;
        window.location = '/application/' + app.id;      
      });
    };

    $scope.cancel = () => {
      $window.history.back();
    };

    $scope.isDataValid = () => {
      if($scope.saving)
        return false;

      if($scope.selectedFile && $scope.selectedFile.filesize > 1024 * 1024)
        return false;

      if(!$scope.appName || $scope.appName.trim() === '')
        return false;

      return true;
    };
  }
}

AppCreateComponent.$inject = ['$http', '$scope', '$state', '$stateParams', '$window'];

export default angular.module('syncplicityLoginApp.createapp', [uiRouter])
  .config(routes)
  .component('createapp', {
    template: require('./createapp.html'),
    controller: AppCreateComponent,
    controllerAs: 'appCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/createapp/createapp.component.js